module.exports = __webpack_public_path__ + "static/img/iphone7-bg.46333f49.jpg";